/**
 * Wize Mobile API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SecurityListMobile { 
    id?: number;
    description?: string;
    shortDescription?: string;
    level1ClassificationId?: string;
    level1Description?: string;
    level2Description?: string;
    favoriteId?: number;
    tradingAllowed?: boolean;
    assetClassType?: SecurityListMobile.AssetClassTypeEnum;
    identifications?: { [key: string]: string; };
    currencyId?: string;
    unitPrice?: number;
    price?: number;
    priceDate: string;
}
export namespace SecurityListMobile {
    export const AssetClassTypeEnum = {
        OTHER_SECURITY: 'OTHER_SECURITY',
        EQUITY: 'EQUITY',
        BONDS: 'BONDS',
        CONVERTIBLE: 'CONVERTIBLE',
        FUND: 'FUND',
        OPTION: 'OPTION',
        FUTURE: 'FUTURE',
        WARRANT: 'WARRANT',
        EQUITY_ETF: 'EQUITY_ETF',
        DERIVATIVE: 'DERIVATIVE',
        PRECIOUS_METAL: 'PRECIOUS_METAL',
        COMMODITIES: 'COMMODITIES',
        INDICE: 'INDICE',
        DEPOSIT_CERTIFICATE: 'DEPOSIT_CERTIFICATE',
        PRIVATE_EQUITY: 'PRIVATE_EQUITY',
        LIQUIDITY: 'LIQUIDITY',
        GUARANTEE: 'GUARANTEE',
        PLEDGE: 'PLEDGE',
        LIMIT: 'LIMIT',
        MONEY_MARKET: 'MONEY_MARKET',
        OTHER: 'OTHER',
        FOREX: 'FOREX',
        EQUITY_FUND: 'EQUITY_FUND',
        BOND_FUND: 'BOND_FUND',
        MONETARY_FUND: 'MONETARY_FUND',
        MIXED_FUND: 'MIXED_FUND',
        REAL_ESTATE_FUND: 'REAL_ESTATE_FUND',
        HEDGE_FUND: 'HEDGE_FUND',
        OTHER_FUND: 'OTHER_FUND',
        BOND_ETF: 'BOND_ETF',
        MORTGAGE_BACKED_SECURITIES: 'MORTGAGE_BACKED_SECURITIES',
        BONDS_FLOATING: 'BONDS_FLOATING',
        INTEREST_FUTURE: 'INTEREST_FUTURE',
        INTEREST_OPTION: 'INTEREST_OPTION',
        INTEREST_DERIVATIVES: 'INTEREST_DERIVATIVES',
        CREDIT_FUTURE: 'CREDIT_FUTURE',
        CREDIT_OPTION: 'CREDIT_OPTION',
        CREDIT_DERIVATIVES: 'CREDIT_DERIVATIVES',
        FOREX_FUTURE: 'FOREX_FUTURE',
        FOREX_OPTION: 'FOREX_OPTION',
        STRUCTURED_PRODUCT: 'STRUCTURED_PRODUCT',
        EQUITY_FUTURE: 'EQUITY_FUTURE',
        EQUITY_OPTION: 'EQUITY_OPTION',
        EQUITY_DERIVATIVE: 'EQUITY_DERIVATIVE',
        COMMODITIES_FUTURE: 'COMMODITIES_FUTURE',
        COMMODITIES_OPTION: 'COMMODITIES_OPTION',
        CONTRACT_FOR_DIFFERENCE: 'CONTRACT_FOR_DIFFERENCE',
        COMMODITIES_ETF: 'COMMODITIES_ETF',
        OTHER_ETF: 'OTHER_ETF',
        COMMODITIES_FUND: 'COMMODITIES_FUND',
        PRIVATE_EQUITY_FUND: 'PRIVATE_EQUITY_FUND',
        BONDS_FUTURE: 'BONDS_FUTURE',
        BONDS_OPTION: 'BONDS_OPTION',
        BONDS_DERIVATIVE: 'BONDS_DERIVATIVE'
    } as const;
    export type AssetClassTypeEnum = typeof AssetClassTypeEnum[keyof typeof AssetClassTypeEnum];
}


